module.exports = __webpack_public_path__ + "img/levi-id.13dfc21e.png";